import { useForm } from '@magicdoorinc/form';
import { Button, createMutation, IconLoader, useLocalization, Panel } from '@magicdoorinc/ui';
import { useNavigate, useSearchParams } from '@solidjs/router';
import { Show } from 'solid-js';
import { useMagicTags } from '~/contexts/global';
import { CustomFieldComponentType } from '~/swagger/portal/Api';
import { AddOrEditTagFormBase, buildSubmitPayload } from './AddOrEditTagFormBase';
import type { Component } from 'solid-js';
import type { EntityType } from '~/swagger/portal/Api';

export const AddMagicTagsPage: Component = () => {
  const { t } = useLocalization();
  const { refetchCustomFields, createCustomFieldMutation, refetchEntityCustomFields } = useMagicTags();

  const [searchParams] = useSearchParams<{ entityType: EntityType }>();

  const navigate = useNavigate();

  const form = useForm({
    initialValues: {
      magicTagType: CustomFieldComponentType.Input,
    },
  });

  const handleDone = createMutation(async () => {
    const { validateStatus } = form.validateForm();
    if (!validateStatus) return;

    const payload = buildSubmitPayload(form.formStore, searchParams.entityType);

    await createCustomFieldMutation(payload);

    refetchCustomFields();
    refetchEntityCustomFields();

    navigate(-1);
  });

  return (
    <div class="flex size-full flex-col">
      <Show
        when={true}
        fallback={
          <Panel class="m-3 flex h-mobileSection flex-col items-center justify-center gap-2 md:m-8 md:h-section1">
            <IconLoader class="animate-spin text-text-02" />
            {t('Loading')}...
          </Panel>
        }>
        <div class="thinscroll flex-1 overflow-auto">
          <Panel class="m-3 flex h-mobileSection flex-col md:m-8 md:h-section1" title={t('Add magic tag')}>
            <div class="thinscroll flex-1 overflow-auto">
              <AddOrEditTagFormBase form={form} entityType={searchParams.entityType} />
            </div>
            <div class="flex h-20 w-full items-center justify-end gap-2 border-t px-8">
              <Button
                variant="outlined"
                onClick={() => {
                  navigate(-1);
                }}>
                {t('Cancel')}
              </Button>
              <Button loading={handleDone.loading} onClick={handleDone}>
                {t('Add')}
              </Button>
            </div>
          </Panel>
        </div>
      </Show>
    </div>
  );
};
